const READY_TIMEOUT = Number(process.env.REACT_APP_GOOGLE_MAPS_TIMEOUT ?? 10000);
const POLL_INTERVAL = 50;

let loadPromise = null;

const isLoaded = () => Boolean(window.google && window.google.maps && window.google.maps.places);

export const loadGoogleMaps = () => {
  if (isLoaded()) return Promise.resolve(window.google);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const startedAt = Date.now();

    const timer = setInterval(() => {
      if (isLoaded()) {
        clearInterval(timer);
        resolve(window.google);
        return;
      }
      if (Date.now() - startedAt >= READY_TIMEOUT) {
        clearInterval(timer);
        loadPromise = null;
        reject(new Error("Google Maps failed to load"));
      }
    }, POLL_INTERVAL);
  });

  return loadPromise;
};

export const loadPlacesLibrary = async () => {
  const google = await loadGoogleMaps();
  if (typeof google.maps.importLibrary === "function") {
    return google.maps.importLibrary("places");
  }
  return google.maps.places;
};
